import React, { useEffect, useState } from 'react';
import { FormLayoutComposer, IFormLayoutProps } from 'components/common/form/renderer/FormLayoutComposer';
import { ActAfterSaveSuccess } from 'components/common/form/act';
import { useFormSlot } from 'components/common/form/layout/control/FormComponentSlot';
import { createPortal } from 'react-dom';
import useWatchFormFieldsChanges from 'components/common/form/hooks/useWatchFormFieldsChanges';
import useWatchFormGridsChanges from 'components/common/form/hooks/useWatchFormGridsChanges';
import { ReIndexRequiredLine, InfoMessageType } from 'components/common/form/layout/helper/ReIndexRequiredLine';

export default function SearchDatasetForm(props: IFormLayoutProps) {
    const infoFields: Array<string> = [];
    const accessFields: Array<string> = [];
    props.componentsMap.forEach((c) => {
        if (c.props.component.component == 'GridComponent') {
            return;
        }
        if (c.tabName == 'info') {
            infoFields.push(c.componentName);
        } else if (c.tabName == 'access') {
            accessFields.push(c.componentName);
        }
    });

    const [formWasSaved, setFormWasSaved] = useState(false);
    useEffect(() => {
        props.hookForm.form.formAct.overrideAct(
            'afterSaveSuccess',
            class extends ActAfterSaveSuccess {
                async exec(response: any, data: any): Promise<any> {
                    setFormWasSaved(true);
                    return super.exec(response, data);
                }
            },
        );
    }, [props.hookForm.form]);

    // Info tab Form section
    const resetInfoFields = useWatchFormFieldsChanges(props.hookForm.form, infoFields, 'infoFieldsChanged');
    const infoFlag = props.hookForm.form.hookFormWatch('infoFieldsChanged');
    const { changedGrids: infoGrids, resetChangedGrids: resetInfoGrids } = useWatchFormGridsChanges(
        props.hookForm.form,
        ['glossary_grid', 'dataset_grid', 'dataset_column_grid'],
    );
    useEffect(() => {
        if (infoGrids.length) {
            props.hookForm.form.hookFormSetValue('infoFieldsChanged', 'Y');
        }
    }, [infoGrids]);

    // Access tab Form section
    const resetAccessFields = useWatchFormFieldsChanges(props.hookForm.form, accessFields, 'accessFieldsChanged');
    const accessFlag = props.hookForm.form.hookFormWatch('accessFieldsChanged');
    const { changedGrids: accessGrids, resetChangedGrids: resetAccessGrids } = useWatchFormGridsChanges(
        props.hookForm.form,
        ['dataset_group_grid'],
    );
    useEffect(() => {
        if (accessGrids.length) {
            props.hookForm.form.hookFormSetValue('accessFieldsChanged', 'Y');
        }
    }, [accessGrids]);

    const [showMessage, setShowMessage] = useState<InfoMessageType>('none');
    useEffect(() => {
        if (infoFlag != '' || accessFlag != '') {
            return;
        }
        setShowMessage('none');
        resetInfoFields();
        resetInfoGrids();
        resetAccessFields();
        resetAccessGrids();
        setFormWasSaved(false);
    }, [infoFlag, accessFlag]);

    useEffect(() => {
        if (!formWasSaved) {
            return;
        }

        if (accessFlag == 'Y') {
            setShowMessage('full');
        } else if (infoFlag == 'Y') {
            setShowMessage('optimized');
        }

        setFormWasSaved(false);
    }, [formWasSaved]);

    const slotComponent = useFormSlot('dShowIndexRequired');
    return (
        <>
            <FormLayoutComposer props={props} />
            {slotComponent &&
                createPortal(
                    <ReIndexRequiredLine
                        form={props.hookForm.form}
                        messageType={showMessage}
                        resetFields={['infoFieldsChanged', 'accessFieldsChanged']}
                    />,
                    slotComponent,
                )}
        </>
    );
}
